"use client"

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Image from "next/image";

import {
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";
import {Separator} from "@/components/ui/separator";

import unitrendLogo from "@/public/logo-unitrend.png";
import unitrendWhiteLogo from "@/public/logo-unitrend-white.png";


import logoUnitrend from "@/public/images/logo-unitrend.png";
import {Button} from "@/components/ui/button";

import {useTheme} from "next-themes";


export default function Footer() {

  const {theme} = useTheme();


  return (
    <div className="py-10 ">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 py-2 w-full px-5">
        <div className="py-4 space-y-5">

          <div className="w-1/2 lg:w-2/5 h-12 lg:h-16 relative">
            {/* {theme == "light" ? <Image
              src={unitrendLogo}
              alt="Unitrend"
              height={30}
              width={150}
              className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
            /> : <Image
              src={unitrendWhiteLogo}
              alt="Unitrend"
              height={30}
              width={150}
              className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
            />} */}
            <Image
              src={theme == "dark" ? unitrendWhiteLogo : unitrendLogo}
              alt="Unitrend"
              height={30}
              width={150}
              className="hover:cursor-pointer h-auto w-[100px] place-items-center flex justify-center"
            />
          </div>
          <p className="mt-3 text-sm font-light">
            Unitrend supports Decision Makers advancing data for better policy.
            We drive change through unravelling data technologies to achieve policy excellence.
          </p>

        </div>

        <div className="py-4 flex justify-end">
          <div>
            <h3 className="font-bold text-lg">
              Kontak kami:
            </h3>
            <div className="mt-5 font-light text-sm">
              <div className="flex items-center mb-4 space-x-5">
                {/* <span className="material-icons mr-5">email</span> */}
                <FontAwesomeIcon icon={faEnvelope} />
                <a className="" href="mailto:partnership@unitrend.id">
                  partnership@unitrend.id
                </a>
              </div>
              <div className="flex items-center mb-4 space-x-5">
                {/* <span className="material-icons mr-5">location_on</span> */}
                <FontAwesomeIcon icon={faLocationDot} />
                <p>
                  Jl. Sosio Yustisia No.1, Bulaksumur, Yogyakarta 55281,
                  Indonesia
                </p>
              </div>

              <div className="flex items-center mb-4 space-x-5">
                {/* <span className="material-icons mr-5">call</span> */}
                <FontAwesomeIcon icon={faPhone} />
                <div>
                  <div className="text-justify">
                    Contact Person :{" "}
                    <a href="https://wa.me/6285179583787">085179583787</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center text-sm mx-auto max-w-7xl w-full px-5 justify-end tracking-wide">
        <Link href={"https://unitrend.id/kebijakan-privasi"}>
          <Button variant={"link"}>
            Kebijakan Privasi
          </Button>
        </Link>
        <Link href={"https://unitrend.id/harga"}>
          <Button variant={"link"}>
            Harga
          </Button>
        </Link>
      </div>

      <div className="py-4 text-sm max-w-7xl w-full mx-auto px-5 tracking-wide">
        Copyright © 2024 Unitrend. All rights reserved.
      </div>
    </div>
  );
}
